import { FC, SVGAttributes } from 'react';

const Send: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4984 2.25033C21.7787 2.43685 21.9315 2.76425 21.8944 3.0989L19.9446 20.6645C19.8445 21.5662 18.7884 22.0023 18.0812 21.434L13.9626 18.1243L9.51596 21.2369C9.20542 21.4543 8.79195 21.4538 8.48194 21.2357C8.17192 21.0175 8.03182 20.6285 8.13156 20.2628L9.63156 14.7628C9.66855 14.6272 9.73682 14.5021 9.83088 14.3975L14.3309 9.39754C14.6634 9.02808 15.2325 8.99813 15.6019 9.33065C15.9714 9.66316 16.0013 10.2322 15.6688 10.6017L11.3119 15.4427L10.5231 18.3347L13.4837 16.2623C13.8116 16.0328 14.2516 16.0474 14.5636 16.2981L18.2861 19.2895L19.913 4.63297L5.42955 12.6793L7.21813 13.1265C7.55555 13.2108 7.81416 13.4821 7.88237 13.8231L8.38237 16.3231C8.47985 16.8105 8.16375 17.2847 7.67635 17.3821C7.18895 17.4796 6.7148 17.1635 6.61732 16.6761L6.22902 14.7346L3.39585 14.0263C2.38386 13.7733 2.20443 12.4119 3.11628 11.9054L20.5628 2.21287C20.8571 2.04935 21.2181 2.0638 21.4984 2.25033Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Send;
